import React from 'react';

type BotListErrorProps = {
  message?: string;
};

const BotListError: React.FC<BotListErrorProps> = ({ message }) => {
  return (
    <div
      style={{
        fontFamily: 'Montserrat',
        fontSize: '18px',
        color: '#d32f2f',
        backgroundColor: 'var(--tint)',
        borderRadius: '20px',
        padding: '40px',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
        marginTop: '20px',
      }}
    >
      <p style={{ margin: 0 }}>
        Failed to load your bots.
      </p>
      {message && (
        <p style={{ marginTop: '8px', fontSize: '14px', color: '#b71c1c' }}>
          {message}
        </p>
      )}
    </div>
  );
};

export default BotListError;
